import { Button, Typography } from '@arionbanki/arionui';
import { PROCESS_STATUS, PROCESS_STATUS_LIST } from 'consts';
import { useDetails } from './useDetails';

export function Details() {
	const { columns, data, t, ...ctx } = useDetails();
	return (
		<div className="row">
			<div className="col-12">
				<Typography TagName="h3">{t('update_process_status')}</Typography>
			</div>
			<div className="col-12 mb-5">
				<form onSubmit={ctx.onSubmit}>
					<div className="form-group">
						<select
							className="form-control mt-3 mb-4"
							id="status"
							name="status"
							onChange={ctx.onSelect}
							value={ctx.selectedStatus}
						>
							{PROCESS_STATUS_LIST.map(i => (
								<option className="dropdown-item" key={i} value={PROCESS_STATUS[i]}>
									{t(PROCESS_STATUS[PROCESS_STATUS[i]])}
								</option>
							))}
						</select>
					</div>
					<div className="row">
						<div className="col-6">
							<Button mode="primary" size="small" type="submit">
								{t('update_process')}
							</Button>
						</div>
						<div className="col-6 text-right">
							<Button mode="error" onClick={ctx.onCancel} size="small">
								{t('cancel_process')}
							</Button>
						</div>
					</div>
				</form>
			</div>
			<div className="col-12">
				<div className="table-responsive">
					{ctx.isLoading && <Typography TagName="p">{t('loading')}</Typography>}
					{ctx.error && <Typography TagName="p">{t('error')}</Typography>}
					{Array.isArray(data) ? (
						<table className="table table-sm table-striped">
							<thead>
								<tr>
									{columns.map(c => (
										<th key={c}>{t(c)}</th>
									))}
								</tr>
							</thead>
							<tbody>
								{data.map(row => (
									<tr key={row.kennitala}>
										{columns.map(field => (
											<td key={field}>{ctx.formatValue(row[field], t)}</td>
										))}
									</tr>
								))}
							</tbody>
						</table>
					) : null}
				</div>
			</div>
		</div>
	);
}
